import { createContext, useState, useContext, useEffect } from "react";

import { Input, HelperText } from '@virkesborsen/ui-component-library';

import { userExists, loginOrRegister } from "../../../api/services/login";
import { getUserData } from "../../../api/services/user";
import { validateEmail, formattedPhoneNumber } from "../helpers";
import { isValidPhoneNumber } from 'react-phone-number-input';

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [isLogged, setIsLogged] = useState(Window.user_data.isLogged ? Window.user_data.loggedInUserID : false);
  const [show, setShow] = useState(false);
  const [view, setView] = useState('start');
  const [data, setData] = useState({marketing_subscribed: true});
  const [userData, setUserData] = useState({});
  const [exists, setExists] = useState(null);
  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  // this state is used to determine what the value is of the first input (email or phone)
  const [inputValue, setInputValue] = useState('');

  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const clearParam=(param,state=null)=>{
      const url = new URL(window.location.href);
      url.searchParams.delete(param);
      history.replaceState(state, '', url.toString());
    }

    if(urlParams) {
      if(urlParams.get("login_view")) {
        open()
        setView(urlParams.get("login_view"))
      }
      if(urlParams.get("login_error")) {
        setErrors(prev => ({...prev, code_error: urlParams.get("login_error")}))
      }
      if(urlParams.get("login_data")) {
        const [dataKey, dataValue] = urlParams.get("login_data").split(':');
        setData(prev => ({...prev, [dataKey]: dataValue}))
      }
      if(urlParams.get("next")) {
        setData(prev => ({...prev, next_url: urlParams.get("next")}))
      }
    }

    fetchUserData()
  }, []);

  useEffect(() => {
    if(show && !isLogged) {
      mixpanel.track("login_start_fe", {});
    }
    
    const Body = document.querySelector('body');
    show ? Body.classList.add('overflow-hidden') : Body.classList.remove('overflow-hidden');
  }, [show]);

  useEffect(() => {
    if(view == 'bankid') {
      mixpanel.track("Login Attempt Clicked BankID Button_FE", {login_method: "QR Code BankID"})
    }
  }, [view]);

  const fetchUserData = async () => {
    const resp = await getUserData();
    setUserData(resp.data)
    return resp.data
  }

  const checkIfRegister = () => {
    if(exists && exists.email == true) {
      return false;
    } else if(exists && (!exists?.mobile_phone_number || !exists?.email)) {
      return true;
    } else {
      return false;
    }
  }

  const checkEmailOrPhonenumber = (val) => {
    if(validateEmail(val)) {
      return 'email';
    } else if(formattedPhoneNumber(val) && isValidPhoneNumber(formattedPhoneNumber(val))) {
      return 'mobile_phone_number';
    } else {
      return false;
    }
  }

  const sendLoginRegister = async () => {
    let payload = {email: data.email, ssn: data.ssn}
    payload.next_url = window.location.pathname + window.location.search

    if(!data.email) {
      payload.mobile_phone_number = data.mobile_phone_number
    } else if(checkIfRegister()) {
      let dataErrors = {}

      if(!data.terms_and_conditions_accepted) {
        dataErrors.terms_and_conditions_accepted = 'Du måste acceptera våra villkor.'
      }

      if(checkEmailOrPhonenumber(data.email) != 'email') {
        dataErrors.email = 'Ogiltig e-postadress.'
      }

      if(checkEmailOrPhonenumber(data.mobile_phone_number) != 'mobile_phone_number') {
        dataErrors.mobile_phone_number = 'Ogiltig telefonnummer.'
      }

      if(Object.keys(dataErrors).length > 0) {
        setErrors(prev => ({...prev, ...dataErrors}))
        return;
      } else {
        payload.mobile_phone_number = data.mobile_phone_number
        payload.marketing_subscribed = data.marketing_subscribed
        payload.roles = data.is_buyer ? ['buyer'] : ['seller']
      }
    }

    setLoading(true)
    const resp = await loginOrRegister(payload);

    if (resp.ok) {
      setData(prev => ({...prev, user_id: resp.data.user_id}))
      setView('code')
    } else {
      if(!exists) {
        mixpanel.track("registration_attempt_fe", {form: 'login_form', errors: resp.error})
      }
      setErrors(resp.error)
    }
    setLoading(false)
    return resp;
  }

  const checkAccountExists = async (val, type=null) => {
    if(!val || val.length == 0) {
      setData(prev => ({...prev, [type]: undefined}))
    } else if(data[type] && val === data[type]) {
      // This is to prevent a double check if formfields change
    } else {
      let valid = false
      if(!type) {
        valid = checkEmailOrPhonenumber(val)
        type = valid
        if(valid) {
          setData(prev => ({...prev, [type]: val}))
          setInputValue('')
        } else {
          setInputValue(val)
          setErrors({null: 'Ogiltig e-postadress eller telefonnummer.'})
        }
      } else {
        if(type != checkEmailOrPhonenumber(val)) {
          const keyToCheck = type === 'email' ? 'mobile_phone_number' : 'email'
          if(!data[keyToCheck]) {
            setInputValue(val)
            setExists(null)
            setData(prev => ({...prev, [type]: undefined}))
          } else if(!checkEmailOrPhonenumber(val)) {
            setData(prev => ({...prev, [type]: val}))
          } else {
            valid = true
            setData(prev => ({...prev, [type]: val}))
          }
        } else {
          setData(prev => ({...prev, [type]: val}))
          valid = true
        }
      }

      if(valid) {
        setLoading(true)
        setErrors(prev => ({...prev, [type]: undefined}))
        let exist = {}
        const resp = await userExists(`${type}=${encodeURIComponent(type === 'mobile_phone_number' ? formattedPhoneNumber(val) : val)}`);
        if (resp.ok) {
          exist[type] = resp.data.exists
          const keyToCheck = type === 'email' ? 'mobile_phone_number' : 'email'
          if(data[keyToCheck]) {
            const respSecond = await userExists(`${keyToCheck}=${encodeURIComponent(keyToCheck === 'mobile_phone_number' ? formattedPhoneNumber(data[keyToCheck]): data[keyToCheck])}`);

            if (respSecond.ok) {
              exist[keyToCheck] = respSecond.data.exists
              setExists(exist)
            }
          } else {
            setExists(exist)
          }
        }
      } else {
        if(type == 'email') {
          setErrors(prev => ({...prev, email: 'Ogiltig e-postadress.'}))
        } 

        if(type == 'mobile_phone_number') {
          setErrors(prev => ({...prev, mobile_phone_number: 'Ogiltig telefonnummer.'}))
        }
      }
      setLoading(false)
    }
  }

  const getFormFields = (secondField=true) => {
    const emailIndex = Object.keys(data).indexOf('email');
    const phoneIndex = Object.keys(data).indexOf('mobile_phone_number');

    const inputs = {
      email: {
        label: 'E-postadress',
        type: 'email',
        value: data.email,
        onChange: (value) => checkAccountExists(value, 'email')
      },
      mobile_phone_number: {
        label: 'Telefonnummer',
        type: 'mobile_phone_number',
        value: data.mobile_phone_number,
        onChange: (value) => checkAccountExists(value, 'mobile_phone_number')
      },
      unkown: {
        label: 'E-postadress eller telefonnummer',
        type: null,
        value: inputValue,
        onChange: (value) => checkAccountExists(value)
      }
    }

    let first = null
    let second = null

    if (!data.email && !data.mobile_phone_number) {
      first = inputs.unkown
    } else if (exists?.email || (data?.email?.length > 0 && emailIndex !== -1) && (!data.mobile_phone_number || (phoneIndex === -1) || emailIndex < phoneIndex)) {
      first = inputs.email
      second = inputs.mobile_phone_number
    } else if (data?.mobile_phone_number?.length > 0 && phoneIndex !== -1) {
      first = inputs.mobile_phone_number
      second = inputs.email
    } else {
      first = inputs.unkown
    }

    return <>
      {first && <>
        <Input tw debounceDelay={500} onFocus={() => setErrors(prev => ({...prev, [first.type]: undefined}))} variant='fluid' className='w-full' isValid={errors[first.type] ? false : null} label={first.label} value={first.value} onChange={first.onChange} />
        {errors[first.type] && <HelperText className='text-danger-500 fill-danger-500 justify-center mt-2' icon='ExclamationFilled' label={errors[first.type]} />}
      </>}

      {second && checkIfRegister() && secondField && <>
        <Input tw debounceDelay={500} onFocus={() => setErrors(prev => ({...prev, [second.type]: undefined}))} variant='fluid' className='w-full mt-4' isValid={errors[second.type] ? false : null} label={second.label} value={second.value} onChange={second.onChange} />
        {errors[second.type] && <HelperText className='text-danger-500 fill-danger-500 justify-center mt-2' icon='ExclamationFilled' label={errors[second.type]} />}
      </>}
    </>
  }

  const onLogin = (userID) => {
    setIsLogged(userID)

    if(data.next_url) {
      window.location.href = data.next_url
    } else if(data.action) {
      fetchUserData()
      close(false)
      const element = document.getElementById(data.action)
      element.tagName == 'FORM' ? element.submit() : element.click()
    } else {
      fetchUserData()
    }
  }

  const open = (data) => {
    if(data) {
      setData(prev => ({...prev, ...data}))
    }
    // This timeout is a temporary fix for development setup where the CSS is not loaded in time somehow. Maybe better fix would be to check if the css is loaded instead.
    setTimeout(() => {
      setShow(true)
    }, 50);
  }

  const close = (show) => {
    setView('start')
    setShow(show)
    setData({marketing_subscribed: true})
    setExists(null)
  }

  return (
    <LoginContext.Provider value={{isLogged, setIsLogged, show, setShow, view, setView, data, setData, userData, exists, setExists, loading, setLoading, errors, setErrors, getFormFields, sendLoginRegister, checkIfRegister, onLogin, open, close}}>
      {children}
    </LoginContext.Provider>
  );
};

export const useLogin = () => useContext(LoginContext);

export default LoginContext;